import { render, staticRenderFns } from "./GuestAccessIcon.vue?vue&type=template&id=b061e1e0&scoped=true"
import script from "./GuestAccessIcon.vue?vue&type=script&lang=js"
export * from "./GuestAccessIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b061e1e0",
  null
  
)

export default component.exports